// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import moment from "moment";

import InspectionTimelineList from "./InspectionTimelineList";
import InspectionTimelineItem from "./InspectionTimelineItem";
import SoftSelect from "components/SoftComponents/SoftSelect";
import { useState } from "react";
import SoftInput from "components/SoftComponents/SoftInput";
import { Box, Card, Grid, Icon } from "@mui/material";
import Divider from '@material-ui/core/Divider';
import FilterPopover from "./FilterPopover";
import SoftButton from "components/SoftComponents/SoftButton";
import { Search } from "@mui/icons-material";

import badgeDict from "modules/inspections/components/badgeDict.json";

function InspectionTimeline({ selected_user, not_found_text, inspections_data, selectedInspection, setSelectedInspection, adjustments, setAdjustments, deviceLayout }) {

    const [search, setSearch] = useState(null);
    

    const organisations_arr = selected_user.organisations.map((org) => {
        return [org, true];
    });

    const sortByOptions = [
        { value: 'date_asc', label: "Date (Asc)" },
        { value: 'date_desc', label: "Date (Desc)" },
        { value: 'name_asc', label: "Title (Asc)" },
        { value: 'name_desc', label: "Title (Desc)" },
        { value: 'status_asc', label: "Status (Asc)" },
        { value: 'status_desc', label: "Status (Desc)" },
    ];

    const conditionFilter = (inspection, filter) => {
        if (filter == false) return true;
        var buildup = [];
        var empty = true;

        for (var cond in filter) {
            if (filter[cond]) {
                empty = false;
                if (cond == 'other') {
                    buildup.push(inspection.devices[0].conditions[cond].length > 0 ? true : false);
                }
                buildup.push(inspection.devices[0].conditions[cond])
            }
        }

        return empty || buildup.filter((row) => row === true).length > 0;
    }


    const timelineFilter = (inspection) => {
        if (adjustments.filter_by == null) {
            return (
                adjustments.startTime.unix() < moment(inspection.createdAt).unix() &&
                adjustments.endTime.unix() >= moment(inspection.createdAt).unix()
            );
        }

        const filters = adjustments.filter_by;
        return (
            conditionFilter(inspection, adjustments.filter_by.conditions) &&
            filters.startTime.unix() < moment(inspection.createdAt).unix() &&
            filters.endTime.unix() >= moment(inspection.createdAt).unix() &&
            filters.statuses[inspection.status] && filters.organisations[inspection.organisation_id]
        );
    }

    const timelineSort = (a, b) => {
        const nameA = a.title.toUpperCase();
        const nameB = b.title.toUpperCase();

        switch (adjustments.sort_by.value) {
            case 'date_asc':
                return moment(a.createdAt).unix() - moment(b.createdAt).unix();
            case 'date_desc':
                return moment(b.createdAt).unix() - moment(a.createdAt).unix();
            case 'name_asc':
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            case 'name_desc':
                if (nameA > nameB) return -1;
                if (nameA < nameB) return 1;
                return 0;
            case 'status_asc':
                return a.status - b.status;
            case 'status_desc':
                return b.status - a.status;
        }
    }

    const searchByFilter = (option) => {

        if (adjustments.search_by == null) {
            return true;
        }

        const searchFor = adjustments.search_by.toLowerCase();

        return (
            option.title != "" && option.title.toLowerCase().includes(searchFor) ||
            option.technician != "" && option.technician.toLowerCase().includes(searchFor) ||
            option.devices.filter((device) => {
                return (
                    device.name != "" && device.name.toLowerCase().includes(searchFor) ||
                    device.stop_id != "" && device.stop_id.toLowerCase().includes(searchFor) ||
                    device.serial_no != "" && device.serial_no.toLowerCase().includes(searchFor)
                    //tags as conditions/actions
                );
            }).length > 0
        )
    }

    const filteredTimelineItems = inspections_data.filter((i) => timelineFilter(i)).sort(timelineSort);
    const searchByTimelineItems = filteredTimelineItems.filter((i) => searchByFilter(i));
    const renderTimelineItems = searchByTimelineItems.map((inspection, index) => {
        var ret = {};

        ret.title = inspection?.inspection?.title || inspection.title;
        if(inspection.record_type == "rectification"){
           ret.secondary_title = inspection?.title;
        }
        else {
            ret.secondary_title = inspection?.rectification?.title;
        }
        ret.dateTime = moment(inspection.createdAt).format("DD/MM/YY hh:mm a")

        if (inspection.devices.length > 1) {
            ret.description = inspection.devices[0].name + ", " + inspection.devices[1].name;
        }
        else {
            ret.description = inspection.devices[0].name;
        }

        ret.badges = [];
        for (var key in inspection.devices[0].conditions) {
            var condition = inspection.devices[0].conditions[key];

            if (condition) {
                ret.badges.push({ ...badgeDict[key] })
            }
        }

        if (inspection.status == 'inspected') {
            ret.color = "info";
            ret.icon = "search";
        }
        else if (inspection.status == 'review') {
            ret.color = "warning";
            ret.icon = "search";
        }
        else if (inspection.status == "unresolved") {
            ret.color = "error";
            ret.icon = "notifications";
        }
        else if (inspection.status == "resolved") {
            ret.color = "success";
            ret.icon = "verified_check";
        }
        else {
            ret.color = "secondary";
            ret.icon = 'question_mark';
        }

        ret.lastItem = inspections_data.length - 1 == index ? true : false;
        ret.isLeft = index % 2 == 0;

        return (<InspectionTimelineItem
            key={index}
            itemData={inspection}
            color={ret.color}
            icon={{ color: ret.color, icon: ret.icon }}
            title={ret.title}
            secondary_title={ret.secondary_title}
            isLeft={ret.isLeft}
            dateTime={ret.dateTime}
            description={ret.description}
            badges={ret.badges}
            lastItem={ret.lastItem}
            selectedInspection={selectedInspection}
            setSelectedInspection={setSelectedInspection}
        />)
    });

    return (
        <SoftBox color={"white"} width="100%" height="100%" sx={({ functions: { rgba } }) => ({ backgroundColor: rgba("#eeeeee", 1), borderRadius: '16px' })}>
            <SoftBox sx={({ functions: { rgba } }) => ({ backgroundColor: rgba("#dcdcdc", 1), borderBottom: "1px solid #8e98a5", borderRadius: '16px 16px 0 0' })}>
                <SoftBox p={1} display="flex" flexDirection={{ xxs: "row" }} sx={{borderRadius: '16px'}}>
                    <SoftBox display="flex" flexDirection="row" width={window.innerWidth < 768 ? '150px !important' : '100%'} minWidth={window.innerWidth < 768 ? '150px !important' : 'unset'}>
                        <SoftBox display="flex" justifyContent="center" mr={{ xxs: 1, md: 2 }}>
                            <FilterPopover {...{ selected_user, adjustments, setAdjustments, deviceLayout }} />
                        </SoftBox>
                        <Divider orientation="vertical" flexItem />
                        <SoftBox mr={{ xxs: 0, md: 2 }} mx={{ xxs: 1, md: 2 }} sx={{ borderRadius: '10px', backgroundColor: '#fff', width: '100%' }}>
                            <SoftSelect
                                value={adjustments.sort_by}
                                options={sortByOptions}
                                onChange={(selected) => {
                                    setAdjustments({
                                        ...adjustments,
                                        sort_by: selected
                                    });
                                }}
                            />
                        </SoftBox>
                    </SoftBox>
                    <Divider orientation="vertical" flexItem />
                    <SoftBox display="flex" justifyContent="center" alignItems="center" width={'100%'} ml={{ xxs: 1, md: 2 }}>
                        <SoftInput
                            placeholder="Search..."
                            value={search}
                            onChange={({ currentTarget }) => {
                                // console.log(search);
                                setSearch(currentTarget.value);
                            }}
                            sx={({ typography: { fontFamily } }) => ({
                                fontFamily: fontFamily,
                                width: '100%'
                            })}

                        />
                        <SoftBox pl={0.5}>
                            <SoftButton
                                variant="gradient"
                                color="dark"
                                onClick={((e) => {
                                    setAdjustments({
                                        ...adjustments,
                                        search_by: search
                                    })
                                })}
                                sx={{ px: 2.5, minWidth: '32px !important', width: '32px !important' }}
                            >
                                <Search />
                            </SoftButton>
                        </SoftBox>
                    </SoftBox>
                </SoftBox>
            </SoftBox>
            <SoftBox sx={{ overflowY: 'auto', height: 'calc(100% - 60px)', minHeight: 'calc(100svh - 16.2rem - 16px)' }}>
                <InspectionTimelineList>
                    {renderTimelineItems.length > 0 ? (
                        renderTimelineItems
                    ) : (
                        <SoftBox p={2} pl={3}>
                            <SoftTypography variant="h5">
                                {not_found_text}
                            </SoftTypography>
                        </SoftBox>
                    )}
                </InspectionTimelineList>
            </SoftBox>
        </SoftBox>
    );
}

InspectionTimeline.propTypes = {
    selected_user: PropTypes.object,
    not_found_text: PropTypes.string,
    inspections_data: PropTypes.array,
    selectedInspection: PropTypes.object,
    setSelectedInspection: PropTypes.func,
    adjustments: PropTypes.object,
    setAdjustments: PropTypes.func,
    deviceLayout: PropTypes.string,
}

export default InspectionTimeline;
